module.exports = __webpack_public_path__ + "img/xds.82e60bc7.png";